export default __webpack_public_path__ + "static/media/right-arrow.61efe42f.svg";